import { Icon } from "@iconify/react";
import {
  Box,
  Button,
  Card,
  Container,
  IconButton,
  Stack,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import AppButton from "../../components/app-button/AppButton";
import Iconify from "../../components/iconify/Iconify";
import {
  addCategory,
  updateCategory,
} from "../../reduxStore/slices/categorySlice";
import { useNotify } from "../../utils/snackbarUtils";
import { useEffect } from "react";

export default function Category() {
  const { showSuccess, handleApiError, showError } = useNotify();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading: isLoading, list } = useSelector((state) => state.category);
  const { user } = useSelector((state) => state.auth);
  const storeId = user?.storeId;
  const { uid } = useParams();

  const [id, setId] = useState("");
  const [categoryName, setCategoryName] = useState("");
  const [desc, setDesc] = useState("");

  useEffect(() => {
    if (uid && list?.length) {
      const category = list.find((a) => Number(a.uid) === Number(uid));

      if (category) {
        setId(category.id || "");
        setCategoryName(category.name || "");
        setDesc(category.description || "");
      } else {
        goToListing();
      }
    }
  }, [uid, list]);

  const goToListing = () => {
    navigate("/app/config/categories");
  };

  const handleSaveCategory = async () => {
    try {
      const obj = {
        store_id: storeId,
        name: categoryName,
        description: desc,
      };
      const res = await dispatch(addCategory(obj)).unwrap();
      showSuccess(res.message);
      goToListing();
    } catch (err) {
      handleApiError(err);
    }
  };

  const handleUpdateCategory = async () => {
    try {
      const obj = {
        id: id,
        uid: Number(uid),
        store_id: storeId,
        name: categoryName,
        description: desc,
      };
      const res = await dispatch(updateCategory(obj)).unwrap();
      showSuccess(res.message);
      goToListing();
    } catch (err) {
      handleApiError(err);
    }
  };

  return (
    <Box p={3}>
      <Container>
        <Box sx={{ maxWidth: "600px", m: "0 auto" }}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            mb={3}
          >
            <Stack direction="row" alignItems="center" spacing={1}>
              <Tooltip title="Back to Categories">
                <IconButton onClick={() => navigate("/app/config/categories")}>
                  <Icon icon="eva:arrow-back-fill" />
                </IconButton>
              </Tooltip>
              <Typography variant="h5">
                {uid ? "Edit Category" : "Add Category"}
              </Typography>
            </Stack>
          </Stack>

          <Card sx={{ p: "30px", maxWidth: "600px", m: "0 auto" }}>
            <Box sx={{ mb: 4 }}>
              <input
                //   onChange={(event) => handleFileChange(event)}
                accept="image/*"
                type="file"
                //   ref={inputFile}
                style={{ display: "none" }}
              />

              <Typography
                sx={{
                  fontSize: 14,
                  color: "#000",
                  mb: 3,
                }}
              >
                Category Image
              </Typography>
              <Box>
                <Box sx={{ mb: 2 }}>
                  <Box
                    sx={{
                      width: 155,
                      height: 155,
                      m: "auto",
                      display: "flex",
                      cursor: "pointer",
                      overflow: "hidden",
                      borderRadius: "15%",
                      alignItems: "center",
                      justifyContent: "center",
                      position: "relative",
                      border: "1px dashed rgba(145, 158, 171, 0.32)",
                    }}
                  >
                    {!false ? (
                      <Link
                        //   onClick={handleFileClick}
                        style={{ textDecoration: "none" }}
                      >
                        <Box
                          sx={{
                            width: 136,
                            height: 136,
                            textAlign: "center",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            flexDirection: "column",
                            color: "rgb(145, 158, 171)",
                            bgcolor: "rgb(244, 246, 248)",
                            transition:
                              "opacity 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
                            borderRadius: "15%",
                          }}
                        >
                          <Iconify sx={{ width: 40 }} icon="mdi:camera-plus" />
                          <Typography sx={{ fontSize: 14 }}>
                            Upload image
                          </Typography>
                        </Box>
                      </Link>
                    ) : (
                      <>
                        <img
                          // src={
                          //   row?.image_url
                          //     ? `${IMAGE_URL}itemcategory/thumbnail?id=${storeId}&img_id=${row.image_url}`
                          //     : file
                          // }
                          alt="img"
                          style={{
                            height: "100%",
                            width: "100%",
                          }}
                        />
                        <IconButton
                          // onClick={handleFileRemove}
                          sx={{
                            position: "absolute",
                            top: 2,
                            right: 2,
                            color: "rgba(255, 255, 255, 0.72)",
                            bgcolor: "rgba(22, 28, 36, 0.48)",
                          }}
                        >
                          <Iconify width={15} icon="material-symbols:close" />
                        </IconButton>
                      </>
                    )}
                  </Box>

                  <Typography
                    sx={{
                      mt: 2,
                      lineHeight: 1.5,
                      fontSize: "0.75rem",
                      fontWeight: 400,
                      color: "rgb(99, 115, 129)",
                      textAlign: "center",
                      display: "block",
                    }}
                  >
                    Allowed *.jpeg, *.jpg, *.png max size of 1 MB
                  </Typography>
                </Box>
              </Box>
            </Box>

            {/* Form */}
            <Stack spacing={3} maxWidth="600px">
              <TextField
                autoComplete="category_name"
                label="Category Name *"
                variant="outlined"
                fullWidth
                value={categoryName}
                onChange={(e) => setCategoryName(e.target.value)}
              />

              <TextField
                autoComplete="category_desc"
                label="Category Description (Optional)"
                variant="outlined"
                fullWidth
                multiline
                rows={2}
                value={desc}
                onChange={(e) => setDesc(e.target.value)}
              />

              {/* Actions */}
              <Stack direction="row" spacing={2} justifyContent="flex-end">
                <Button onClick={() => navigate("/app/config/categories")}>
                  Cancel
                </Button>
                <AppButton
                  disabled={isLoading}
                  isLoading={isLoading}
                  onClick={uid ? handleUpdateCategory : handleSaveCategory}
                  variant="contained"
                >
                  {uid ? "Update" : "Save"}
                </AppButton>
              </Stack>
            </Stack>
          </Card>
        </Box>
      </Container>
    </Box>
  );
}
